import { render, staticRenderFns } from "./tree-node-dialog.vue?vue&type=template&id=4bc8bc7a&"
import script from "./tree-node-dialog.vue?vue&type=script&lang=ts&"
export * from "./tree-node-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./tree-node-dialog.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports